module.exports = __webpack_public_path__ + "img/template-2.26ac0fe1.svg";